import React from "react";
import PropTypes from "prop-types";
import { controlPropTypes } from "../formhelpers";
import classnames from "classnames";
import isMissing from "data/util/isMissing";

export default function ControlTemplate({
                                            className,
                                            descriptor,
                                            controlOnly,
                                            enabled,
                                            value,
                                            children,
                                            controlRef,
                                            extraProps = {},
                                        }) {
    if (descriptor.disableBehaviour === "hide" && !enabled) {
        // control is disabled and should be hidden.
        return null;
    }

    const selector = `control-container-${descriptor.key}`;
    const required = enabled && descriptor.required;

    const Control = (
        <div
            ref={controlRef}
            id={descriptor.id}
            className={classnames(
                selector,
                "control",
                "react-control",
                className,
                {
                    "control-only": controlOnly,
                    "required": required,
                    "illegal": required && isMissing(value),
                },
            )}
            data-control-type={descriptor.control}
            data-shortname={descriptor.key}
            {...extraProps}
        >
            {children && children}
        </div>
    );

    if (controlOnly) {
        return Control;
    }

    return (
        <div className="form-item">
            <div className="left-side">
                <label>{descriptor.label}</label>
            </div>
            <div className="right-side">
                {Control}
            </div>
        </div>
    );

}

ControlTemplate.propTypes = {
    ...controlPropTypes(null, false),
    onCommitChange: PropTypes.func,
    children: PropTypes.any,
    controlRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/ControlTemplate.js